<!--
  OrangeHRM Calendar Plugin — Month View Grid
-->
<template>
  <div class="cal-grid-wrapper">
    <!-- Day-of-week labels -->
    <div class="cal-day-labels">
      <div v-for="label in DAY_LABELS" :key="label" class="cal-day-label">
        {{ label }}
      </div>
    </div>

    <!-- Date cells -->
    <div class="cal-grid">
      <DayCell
        v-for="day in days"
        :key="day.dateKey"
        :day="day"
        :events="eventsByDay.get(day.dateKey) || []"
        :holidays="holidaysByDay.get(day.dateKey) || []"
        :workweek="workweek"
        :is-admin="isAdmin"
        @day-click="$emit('day-click', $event)"
        @event-click="$emit('event-click', $event)"
        @holiday-click="$emit('holiday-click', $event)"
        @add-holiday-date="$emit('add-holiday-date', $event)"
      />
    </div>
  </div>
</template>

<script>
import {DAY_LABELS} from '../utils/calendarUtils';
import DayCell from './DayCell.vue';

export default {
  name: 'MonthView',

  components: {DayCell},

  props: {
    days: {type: Array, required: true},
    eventsByDay: {type: Map, required: true},
    holidaysByDay: {type: Map, required: true},
    workweek: {type: Object, default: null},
    isAdmin: {type: Boolean, default: false},
  },

  emits: ['day-click', 'event-click', 'holiday-click', 'add-holiday-date'],

  setup() {
    return {DAY_LABELS};
  },
};
</script>
